// Copyright (c) Codicent Inside AB. All rights reserved.
// This software and its associated documentation files (the "Software") are
// proprietary to Codicent Inside AB. Unauthorized copying of this file, via any
// medium is strictly prohibited. The Software is provided "AS IS", without
// warranty of any kind, express or implied, including but not limited to the
// warranties of merchantability, fitness for a particular purpose, and
// noninfringement. In no event shall the authors or copyright holders be liable
// for any claim, damages, or other liability, whether in an action of contract,
// tort, or otherwise, arising from, out of, or in connection with the Software
// or the use or other dealings in the Software.
 

// SDK calls from inside SDK
// import { makeStyles, tokens } from "@fluentui/react-components";
import { useState, useEffect } from "react";
import { Link } from "react-router";
// import { CodicentAppState } from "../hooks";
// import { Button, Spinner, Text, Title } from "../components";
// import { getConfigValue } from "../config";

// SDK calls as page
import {
  CodicentAppState,
  getConfigValue,
  useLocalization,
  // Button,
  // Spinner,
  // Text,
  // Title,
} from "codicent-app-sdk";
// import { STRIPE_PAYMENT_LINK } from "@/constants";

// Reqtangle
import { Button } from "@/components/ui/button";
// import { useAuth0 } from "@auth0/auth0-react";

const CustomSpinner = () => (
  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-900"></div>
);

export const Purchase = ({ state }: { state: CodicentAppState }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [countdown, setCountdown] = useState(10);
  const {
    service,
    stateMachine
  } = state;  
  const { updateContext } = stateMachine;
  const { t } = useLocalization();
  // const { user } = useAuth0();
  // const auth0UserIdforURL = user?.sub?.replace('auth0|', '');
  // const userEmail = user?.email;

  useEffect(() => {
    // Handle return from Stripe
    const queryParams = new URLSearchParams(window.location.search);
    const sessionId = queryParams.get("session_id");

    if (sessionId) {
      // Handle successful payment here
      // You might want to validate the session with your backend
      // TODO: move the following to codicentservice
      updateContext({ hasValidPurchase: undefined }); // this will trigger a new check of subscription status
      // navigate("./", { replace: true }); // Navigate to root, replacing current history entry
      // service
      //   .checkSubscriptionStatus()
      //   .then((status) => {
      //     if (status === "active") {
      //       setPaid();
      //     }
      //   })
      //   .catch((error: unknown) => {
      //     console.error("Failed to check subscription status", error);
      //   });
    }
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (countdown === 0) {
      handlePurchase();
    }
  }, [countdown]);

  const handlePurchase = async () => {
    try {
      setIsLoading(true);
      // Using the price ID for your subscription plan
      await service.redirectToCheckout(getConfigValue("STRIPE_PRICE_ID"));
      
      // Stripe Payment Link
      // const stripeUrl = `${STRIPE_PAYMENT_LINK}?client_reference_id=${encodeURIComponent(auth0UserIdforURL || '')}${userEmail ? `&prefilled_email=${encodeURIComponent(userEmail)}` : ''}`;
      // window.location.href = stripeUrl;

    } catch (error) {
      console.error("Purchase error:", error);
      // You might want to show an error message to the user
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center gap-10 px-6 py-24">
      <img 
        src="/images/logo512.png" 
        alt="Reqtangle Logo" 
        className="w-24 h-24"
      />
      <h1 className="text-xl font-bold">{t("Start your subscription")}</h1>
      <div className="text-md">
          {t("You will be automatically redirected to checkout in")} {countdown} {t("seconds")}
      </div>
      <div className="flex gap-4 mt-4">
        <Button asChild variant="ghost" disabled={isLoading}>
          <Link to="/logout">{t("Log out")}</Link>
        </Button>
        <Button onClick={handlePurchase} disabled={isLoading}>
          {isLoading ? <CustomSpinner /> : t("Go directly to checkout")}
        </Button>
      </div>
    </div>
  );
};

export default Purchase;